<template>
  <div class="header">
    <div style="display: flex;align-items:center;flex:1;" v-show="$route.path!='/studentAccount' && $route.path!='/selectSubscribed'&& $route.path!='/help'">
      <div class="box-grade cursor-pointer">
        <span @click="showAll=!showAll">{{currentGradeName||detail.subscriptions[detail.subscriptionIndex].gradeName}}<i class="el-icon-caret-bottom"></i></span>
        <div v-if="showAll" class="box-grades">
          <div class="grades" :class="gradeId==item.id?'active':''" v-for="(item,index) in detail.subscriptions[detail.subscriptionIndex].subscribeAssignGrades" :key="index" @click="gradeChange(item)">{{item.name }}</div>
        </div>
      </div>
      <div v-if="$route.path=='/adventure'" class="box-star">0/72</div>
    </div>
    <div v-show="$route.path=='/studentAccount' || $route.path=='/selectSubscribed'|| $route.path=='/help'" style="flex:1;"></div>
    <div class="title headerGuide1" ref="headerGuide1" :style="{opacity:$route.path=='/adventure'?'50%':''}">
      {{$route.path=='/answerResult'?$t("studentProgramme.answerRecord"):$route.path=='/studentAccount'?$t("studentProgramme.myFile"):$route.path=='/adventure'?$t("studentProgramme.adventureMode"):$route.path=='/libraryMode'?$t("studentProgramme.libraryMode"):$route.path=='/selectSubscribed'?$t("studentProgramme.courseSwitching"):$route.path=='/testMode'?$t("studentProgramme.homework"):''}}
    </div>
    <div style="display: flex;flex:1;justify-content:flex-end;" v-show="$route.path!='/help'">
      <div class="box-mode">
        <div class="box-bg1 cursor-pointer"  :class="$route.path=='/adventure'?'active':''" @click="modeChange(1)">
        </div>
        <span class="text">{{ $t("studentProgramme.adventureMode") }}</span>
      </div>
      <div class="box-mode" style="margin:0 1rem;">
        <div class="box-bg2 cursor-pointer" :class="$route.path=='/libraryMode'?'active':''" @click="modeChange(2)">
        </div>
        <span class="text">{{ $t("studentProgramme.libraryMode") }}</span>
      </div>
      <div class="box-mode">
        <div class="box-bg3 cursor-pointer" :class="$route.path=='/testMode'?'active':''" @click="modeChange(3)">
        </div>
        <span class="text">{{ $t("studentProgramme.homework") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      detail: {
        type: Object,
        default: function () {},
      },
    },
    data() {
      return {
        currentGradeName:null,
        showAll:false,
        gradeId:1
      };
    },
    mounted () {
      this.gradeId = this.$store.getters.currentGradeId
      this.currentGradeName=this.detail.subscriptions[this.detail.subscriptionIndex].subscribeAssignGrades.filter(item=>item.id==this.gradeId)[0].name
    },
    methods: {
      getGrade(gradeId){
        this.gradeId = gradeId
        this.$store.dispatch('setGradeId', gradeId);
        this.currentGradeName=this.detail.subscriptions[this.detail.subscriptionIndex].subscribeAssignGrades.find(item=>item.id==this.gradeId)?.name||this.detail.subscriptions[this.detail.subscriptionIndex].gradeName
      },
      gradeChange(item){
        this.currentGradeName=item.name
        this.gradeId=item.id
        this.$store.dispatch('setGradeId', item.id);
        this.$emit('gradeChange', item.id);
        this.showAll=false
      },
      modeChange(index){
        if(index==1)this.$router.push({ path: "/adventure" });
        if(index==2)this.$router.push({ path: "/libraryMode" });
        if(index==3)this.$router.push({ path: "/testMode" });
      }
    },
  };
</script>

<style lang="scss" scoped>
.header{
  position: absolute;
  top:0;
  left:0;
  right:0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0.5rem 2.5vw;
  font-weight: bold;
}
.box-grade{
  padding: 0.5rem 0;
  background-color: #F9F7F2;
  box-shadow: 0px 0.25rem 0.25rem 0px #DEF0F8;
  font-size: 3rem;
  line-height: 3.5rem;
  border-radius: 10rem;
  position: relative;
  span{
    padding: 0 0.75rem;
  }
  .el-icon-caret-bottom{
    vertical-align:0.75rem;
    margin-left: 1rem;
    font-size: 1rem;
    padding:0.75rem;
    color: #ffffff;
    border-radius: 50%;
    background-color: #F1AA55;
    box-shadow: 0px 0.5rem 0px #D07D11;
  }
  .box-grades{
    margin-top:1.5rem;
    position: absolute;
    background: #F9F7F2;
    border-radius: 1.25rem;
    width: 100%;
    padding:0.25rem 0;
    font-size: 1.5rem;
    line-height: 2rem;
    z-index: 2000;
    .grades{
      border-radius: 0.75rem;
      margin: 0.75rem;
      padding: 1rem 0.75rem;
      &.active{
        background-color: #F6C98E;
      }
    }
  }
}
.box-star{
  margin-left: 4.25rem;
  padding: 0.375rem 1.5rem;
  background-color: #F9F7F2;
  box-shadow: 0px 0.25rem 0.5rem 0px #DEF0F8;
  border-radius: 0.625rem;
  position:relative;
  &::before{
    content:"";
    background-image: url("~@/assets/images/star-semi.png");
    position: absolute;
    height: 4rem;
    width: 4rem;
    top:-1rem;
    left:-3rem;
    background-size: contain;
  }
}
.title{
  color: #ffffff;
  font-size: 3rem;
  flex:1;
  text-align: center;
  font-weight: 700;
  font-family: "GenSenRoundedTW", "Helvetica", "Arial";
  text-shadow: 0px 4px 4px rgba(0,0,0,0.8);
}
.box-mode{
  display: flex;
  flex-direction:column;
  align-items:center;
  [class^=box-bg]{
    background-color: #CCCCCC;
    background-size: 75% auto;
    background-repeat: no-repeat;
    background-position: center center;
    box-shadow: 0px 0.375rem 0px #DDA516, 0px 0.1875rem 0px #DDA516 inset;
    border: 0.375rem solid #FCC03A;
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
    &.active{
      background-color: #FCC03A;
    }
  }
  .box-bg1{
    background-image: url("~@/assets/images/adventure-mode.png");
  }
  .box-bg2{
    background-image: url("~@/assets/images/library-mode.png");
  }
  .box-bg3{
    background-size: 60% auto;
    background-image: url("~@/assets/images/homework-mode.png");
  }
  .text{
    margin-top:0.875rem;
    font-size: 1.5rem;
    line-height: 1;
    color: #ffffff;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .title{
        font-size: 2rem;
    }
  .box-mode{
    .text{
      font-size:1rem;
    }
  }
  .box-grade{
    font-size:2rem;
  }
  
}
@media (min-width: $minWidth) and (max-width: $maxWidth) {
  
}

</style>


